<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>

            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner/>
            </div>

            <div v-else>
                <ion-grid>
                    <ion-row>
                        <ion-col size-xl="7"
                                 size-md="6"
                                 size-xs="12">
                            <ion-segment :value="activeCollection"
                                         v-model="activeCollection"
                                         @ionChange="activeCollection = $event.detail.value"
                                         style="border-bottom: 1px solid #e1e1e1;">
                                <ion-segment-button v-for="(name, id) in collections"
                                                    :key="id"
                                                    :value="id"
                                                    style="padding-bottom: 5px;">
                                    <ion-label v-text="name"/>
                                </ion-segment-button>
                            </ion-segment>

                            <ion-row>
                                <ion-col v-for="category in categories"
                                         :key="category.id"
                                         size-xl="3"
                                         size-md="4"
                                         size-xs="12">
                                    <ion-list>
                                        <ion-list-header lines="inset"
                                                         :style="'font-size: 110%; border-bottom: 2px solid ' + category.color + ';'">
                                            <ion-label v-text="category.name"/>
                                        </ion-list-header>

                                        <ion-item v-for="linkItem in category.links"
                                                  :key="linkItem.id"
                                                  lines="none">
                                            <ion-icon slot="start"
                                                      size="small"
                                                      ios="globe"
                                                      md="globe"
                                                      style="margin-right: 16px;"
                                                      :title="linkItem.url"/>

                                            <a :href="linkItem.url"
                                               class="secure-link"
                                               target="_blank">
                                                {{ linkItem.name }}
                                            </a>
                                        </ion-item>
                                    </ion-list>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                        <ion-col size-xl="5"
                                 size-md="6"
                                 size-xs="12">
                            <message-board/>
                        </ion-col>
                    </ion-row>
                </ion-grid>

                <ion-button href="PVLoader_MSI.msi"
                            target="_blank"
                            v-if="$root.isWindows"
                            size="small"
                            style="position: absolute; bottom: 0; left: 0;">
                    <ion-icon ios='download'
                              md="download"
                              slot="start"/>

                    Download software om Windows links te open
                </ion-button>
            </div>
        </ion-content>
    </ion-page>
</template>
<script>
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import HeaderMenu from "../../components/nav/HeaderMenu";
    import {ApiError} from "@/errors/ApiError";
    import MessageBoard from "@/components/message-board/MessageBoard";

    export default {
        components: {
            MessageBoard,
            HeaderMenu,
            FlashMessages,
            DefaultHeader,
        },
        data() {
            return {
                loading: true,
                collections: [],
                activeCollection: null,
                categories: [],
            }
        },
        watch: {
            // whenever question changes, this function will run
            activeCollection(id) {
                this.loading = true;

                this.$http.get('/safe-links/collections/' + id)
                    .then(async ({data}) => {
                        if (! data) {
                            new ApiError(data);
                            return;
                        }

                        this.categories = data;
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => this.loading = false);
            }
        },
        methods: {
            loadCollections() {
                this.loading = true;

                this.$http.get('/safe-links/collections')
                    .then(async ({data}) => {
                        if (! data) {
                            new ApiError(data);
                            return;
                        }

                        this.collections = data;

                        if (this.collections) {
                            const ids = Object.keys(this.collections);

                            if (ids.length) {
                                this.activeCollection = ids.first();
                            }
                        }
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => this.loading = false);
            },
        },
        mounted() {
            this.loadCollections();
        },
    }
</script>

<style>
    .secure-link {
        color: inherit;
        text-decoration: none;
    }

    .secure-link:hover {
        text-decoration: underline;
    }
</style>
